import {html, LitElement, nothing} from '../lib/lit-html.js';
import {classMap} from '../lib/lit/directives/class-map.js';

function editUrl(productId){
	var url = new URL(
		`./index.asp?function=EDITITEM&type=PRODUCT&location=0`,
		window.location.href
	);
	url.searchParams.set('id', productId);
	return url;
}

function deleteUrl(productId){
	var url = new URL(
		'./index.asp?function=DELETEITEM&type=PRODUCT-YES&location=0&page=index.asp',
		window.location.href
	);
	url.searchParams.set('id', productId);
	return url;
}

function toggleHiddenUrl(productId, status){
	var url = new URL(
		'./index.asp?function=EDITITEM&type=PRODUCT-CATEGORY-SHOWHIDE&porc=product',
		window.location.href
	);
	url.searchParams.set('id', productId);
	url.searchParams.set('ProductStatus', status);
	return url;
}

const boundMap = new WeakMap();

function bound(obj, fn){
	const fns = (boundMap.has(obj))
		? boundMap.get(obj)
		: boundMap.set(obj, {}).get(obj);

	const bound = fns[fn.name] || (fns[fn.name] = fn.bind(obj));

	return bound;
}

export class EkmEditProductButton extends LitElement {
	static get properties(){
		return {
			productId: {type: Number},
			productHidden: {type: Boolean},
			subMenuHidden: {type: Boolean},
			deleteable: {type: Boolean},
			hideable: {type: Boolean},
		};
	}

	constructor(){
		super();
		this.productHidden = false;
		this.subMenuHidden = true;
		this.deleteable = false;
		this.hideable = false;
	}

	connectedCallback(){
		super.connectedCallback();
		window.addEventListener('click', bound(this, this._winClick));
	}

	disconnectedCallback(){
		window.removeEventListener('click', bound(this, this._winClick));
		super.disconnectedCallback();
	}

	render(){
		const href = editUrl(this.productId).href;

		return html`
			<div
			class="ekm-edit-button-wrapper ekm-viewShop ekm-viewShop-product u-display--inline-block"
			style="visibility:inherit;">
				<a
				title="Edit Product"
				class="ekm-edit-button"
				href=${href} title="Edit Product"
				@click=${this._onClick}></a>
				${(this.subMenuHidden) ? nothing : this._renderMenu()}
			</div>
		`;
	}

	_renderMenu(){
		var hiddenClass = {
			'ekm-hideico': !this.productHidden,
			'ekm-showico': this.productHidden,
		};

		const deleteButton = (!this.deleteable)
			? nothing 
			: html`
				<a
				class="ekm-actionmenuitem ekm-delico"
				title="Delete Product"
				@click=${this._onDeleteClick}
				>Delete</a>
			`;

		const visibilityToggle = (!this.hideable)
			? nothing
			: html`
				<a
				class="ekm-actionmenuitem ${classMap(hiddenClass)}"
				title="Toggle Hidden"
				@click=${this._onHiddenClick}
				>Hide</a>
			`;

		return html`
			<div
			class="ekm-actionmenu ekm-viewShop ekm-viewShop-product"
			style="top:0"
			@mouseenter=${this._menuMouseEnter}
			@mouseleave=${this._menuMouseLeave}>
				<a
				class="ekm-actionmenuitem ekm-editico"
				title="Edit Product"
				@click=${this._onEditClick}
				>Edit</a>

				${deleteButton}
				${visibilityToggle}
				
			</div>
		`;
	}

	createRenderRoot(){
		return this;
	}

	_onClick(event){
		event.preventDefault();

		if (!this.hideable && !this.deleteable){
			window.top.openModalEditItem(editUrl(this.productId).href);
			return;
		}

		this.subMenuHidden = !this.subMenuHidden;
	}

	_onEditClick(event){
		event.preventDefault();
		window.top.openModalEditItem(editUrl(this.productId).href);
	}

	_onDeleteClick(event){
		event.preventDefault();
		ekmConfirmAction(
			'Are you sure you want to delete the \'lego man\' product?',
			'Yes, delete it',
			deleteUrl(this.productId).href
		);
	}

	_onHiddenClick(event){
		event.preventDefault();
		fetch(toggleHiddenUrl(this.productId, this.productHidden)).then(res => {
			if (!res.ok) return;
			this.productHidden = !this.productHidden;
			this.requestUpdate();
		});
	}

	_menuMouseEnter(event){
		clearTimeout(this._menuTimeout);
	}

	_menuMouseLeave(event){
		this._menuTimeout = setTimeout(() => {
			this.subMenuHidden = true;
			this.requestUpdate();
		}, 500);
	}

	_winClick(event){
		if (event.target.closest(this.nodeName) === this) return;
		this.subMenuHidden = true;
		this.requestUpdate();
	}
}

customElements.define('ekm-edit-product-button', EkmEditProductButton);